import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Ng2IzitoastService } from 'ng2-izitoast';
import { CatalogosService } from 'src/app/services/catalogos.service';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'app-fotos-grupos',
  templateUrl: './fotos-grupos.component.html',
  styleUrls: ['./fotos-grupos.component.scss']
})
export class FotosGruposComponent implements OnInit {
  environment = environment.BASE_URL
  myFiles:string [] = [];
  respuestaAgregar:any;
  grupoId:any;
  data:any;
  fotos:any;

  constructor(private _agregarFoto: CatalogosService, private iziToast: Ng2IzitoastService,
    private actRoute: ActivatedRoute) { }

  ngOnInit(): void {
    this.actRoute.paramMap.subscribe(params => {
      this.grupoId = this.actRoute.snapshot.paramMap.get('grupo');
      });

      this.getFotosGrupo(); 
  }

  onFileChange(event) {
    for (var i = 0; i < event.target.files.length; i++) { 
        this.myFiles.push(event.target.files[i]);
    }
  }

  getFotosGrupo(){
    this.data = {
      'grupo': this.grupoId
    }
    
    this._agregarFoto.getFotosGrupo(this.data).subscribe(
      data => {
        this.respuestaAgregar = data;
        if(this.respuestaAgregar.success){
          this.fotos = this.respuestaAgregar.content;
          
        }else {
          alert('No se cargaron los datos');
        }
      }, error => console.error(error));
  }

  eliminarFotoGrupo(foto){
    this.data = {
      'foto': foto,
    }
    
    this._agregarFoto.eliminarFotoGrupo(this.data).subscribe(
      data => {
        this.respuestaAgregar = data;
        if(this.respuestaAgregar.success){
          this.fotos = this.respuestaAgregar.content;
          this.iziToast.show(
            {
                title: 'Se ha eliminado correctamente.',
                titleColor: '#f8f8ff',
                color: '#4CAF50',
                position: 'topRight',
                closeOnEscape: true,
            });
          this.getFotosGrupo();
        }else {
          alert('No se cargaron los datos');
        }
      }, error => console.error(error));
  }

  agregarFotos(){
    const formData = new FormData();
    formData.append('grupo', this.grupoId);
    for (var i = 0; i < this.myFiles.length; i++) { 
      formData.append("archivos", this.myFiles[i]);
    }

    this._agregarFoto.agregarFotosGrupo(formData).subscribe(
      data => {
        this.respuestaAgregar = data;
        if(this.respuestaAgregar.success){
          this.iziToast.show(
            {
                title: 'Se ha agregado correctamente.',
                titleColor: '#f8f8ff',
                color: '#4CAF50',
                position: 'topRight',
                closeOnEscape: true,
            });
          this.getFotosGrupo();
          
        }else {
          alert('No se cargaron los datos');
        }
      }, error => console.error(error));

  }

  descargarImagen(imagen){
    var xhr = new XMLHttpRequest();
    var url = this.environment+imagen
    xhr.open("GET", url, true);
    xhr.responseType = "blob";
    xhr.onload = function(){
        var urlCreator = window.URL || window.webkitURL;
        var imageUrl = urlCreator.createObjectURL(this.response);
        var tag = document.createElement('a');
        tag.href = imageUrl;
        tag.download = imagen;
        document.body.appendChild(tag);
        tag.click();
        document.body.removeChild(tag);
    }
    xhr.send();
  }
 

}
